import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import SearchField from 'components/atoms/SearchField'
import BlueCheckbox from 'components/atoms/BlueCheckbox'
import TablePreloader from 'components/atoms/TablePreloader'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

const styles = theme => ({
  root: { minWidth: 700 },
  subtitle: { color: theme.palette.disabled.main },
  body: {
    height: 250,
    overflowY: 'scroll',
    margin: `${theme.spacing(3)
    }px 0`,
    padding: `0 ${theme.spacing(3)}px`,
    borderTop: `1px solid ${theme.palette.background.medium} `,
    borderBottom: `1px solid ${theme.palette.background.medium} `,
  },
  header: {
    padding: `${theme.spacing(3)} px 0 0`,
    paddingRight: theme.spacing(3),
  },
  selectAll: {
    width: 100,
    display: 'flex',
    justifyContent: 'space-between',
  },
  footer: {
    height: 50,
  },
  clearContainer: {
    animation: 'fadeIn .3s ease',
    color: theme.palette.disabled.main,
  },
  new: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  newCheckbox: {
    width: 50,
    paddingTop: 20,
    textAlign: 'right',
  },
  newText: {
    color: theme.palette.primary.main,
  },
  underline: {
    cursor: 'pointer',
    borderBottom: `1px solid ${theme.palette.background.medium} 75`,
  },
  newGroupInput: {
    '&:not(:focus)': {
      cursor: 'pointer',
    },
  },
  button: {
    marginLeft: theme.spacing(3),
  },
  preloader: {
    marginTop: 50,
  },
})

const AssignGroupsPopover = ({
  data,
  groups,
  classes,
  loading,
  newGroupName,
  bulkSelected,
  onClearClick,
  onBulkSelect,
  selectedGroups,
  onSearchChange,
  onConfirmClick,
  onNewGroupSelect,
  newGroupSelected,
  renderGroupsList,
  onGroupTextChange,
}) => (
  <div className={classes.root}>
    <Typography variant="h1">Assign access to groups</Typography>
    {data && data.requestCount && (
      <Typography className={classes.subtitle}>
        {data.requestCount} new contributor{data.requestCount > 1 && 's'}
      </Typography>
    )}
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={classes.header}>
      <SearchField onChange={onSearchChange} width={300} />
      <div className={classes.selectAll}>
        <Typography>Select All</Typography>
        <BlueCheckbox checked={bulkSelected} onChange={onBulkSelect} />
      </div>
    </Grid>
    <section className={classes.body}>
      <div className={classes.new}>
        <TextField
          fullWidth
          margin="normal"
          id="name-input"
          autoComplete="name"
          value={newGroupName}
          label="+ Create new group"
          InputLabelProps={{
            className: classes.newText,
          }}
          InputProps={{
            disableUnderline: true,
            classes: {
              root: classes.underline,
              input: newGroupName.length === 0 ? classes.newGroupInput : null,
            },
          }}
          onChange={onGroupTextChange}
        />
        <div className={classes.newCheckbox}>
          {newGroupName && newGroupName.length > 0 && (
            <BlueCheckbox
              checked={newGroupSelected}
              onChange={onNewGroupSelect}
            />
          )}
        </div>
      </div>
      {groups
        ? renderGroupsList()
        : loading && <TablePreloader className={classes.preloader} />}
    </section>
    <Grid
      container
      justify="flex-end"
      alignItems="center"
      className={classes.footer}>
      <Grid item>
        <Grid container alignItems="center" className={classes.clearContainer}>
          <Typography color="inherit">
            {newGroupName && newGroupSelected ? '1 new group, ' : ''}
            {selectedGroups.length} group{selectedGroups.length !== 1 && 's'}{' '}
            selected
          </Typography>
          <SubmitButton
            size="medium"
            loading={false}
            color="primary"
            variant="secondary"
            onClick={onClearClick}
            className={classes.button}>
              Clear
          </SubmitButton>
        </Grid>
      </Grid>
      <SubmitButton
        size="medium"
        loading={false}
        color="primary"
        variant="primary"
        onClick={onConfirmClick}
        className={classes.button}
        disabled={selectedGroups.length === 0 && !newGroupSelected}>
          Assign
      </SubmitButton>
    </Grid>
  </div>
)

AssignGroupsPopover.propTypes = {
  loading: PropTypes.bool,
  groups: PropTypes.object,
  classes: PropTypes.object,
  data: PropTypes.shape({
    requests: PropTypes.array,
  }),
  bulkSelected: PropTypes.bool,
  onClearClick: PropTypes.func,
  onBulkSelect: PropTypes.func,
  onSearchChange: PropTypes.func,
  onConfirmClick: PropTypes.func,
  newGroupName: PropTypes.string,
  selectedGroups: PropTypes.array,
  renderGroupsList: PropTypes.func,
  newGroupSelected: PropTypes.bool,
  onNewGroupSelect: PropTypes.func,
  onGroupTextChange: PropTypes.func,
}

export default withStyles(styles)(AssignGroupsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignGroupsPopover/AssignGroupsPopover.js